module.exports = __webpack_public_path__ + "img/edit.fd591911.svg";